export default "__VITE_ASSET__BPYKyev8__"